import { EventEmitter, Inject, Injectable, Output } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { BehaviorSubject, of, ReplaySubject, Subject } from "rxjs";
import { jwtDecode } from 'jwt-decode';
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class OktaWrapperService {

  private heldToken?: HeldToken;
  private currentUser?: ICurrentUser;
  private currentUserSubject = new BehaviorSubject<ICurrentUser | undefined>(undefined);
  public currentUser$ = this.currentUserSubject.asObservable();

  public authenticationChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Output() loggedOut: EventEmitter<void> = new EventEmitter();

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
    this.oktaAuth.isAuthenticated().then(async (t) => {
      this.oktaAuth.getUser().then((user) => {
        const _user = {...user, email: 'Client_demo@greentree.com'};
        this.currentUser = _user as any;
        this.currentUserSubject.next(this.currentUser);
      })
    })
    // Bind into the Okta token Manager to monitor token events

    const tokenManager = this.oktaAuth.tokenManager;
    tokenManager.on('added', (key: any, token: any) => {
      if (key == 'accessToken') {
        this.heldToken = { token: token.accessToken, expiresAt: new Date(token.expiresAt * 1000) };
        this.currentUser = jwtDecode(this.heldToken.token);
        this.currentUserSubject.next(this.currentUser); // emit only when updated
        this.authenticationChanged.next(true);
      }
    });

    tokenManager.on('expired', (key: any, expiredToken: any) => {
      if (key == 'accessToken') {
        this.heldToken = undefined;
        this.currentUser = undefined;
        this.currentUserSubject.next(undefined); // emit only when expired
        this.authenticationChanged.next(false);
      };
    });

    tokenManager.on('renewed', (key: any, oldToken: any, newToken: any) => {
      console.log('Token Renewed');
    });

    tokenManager.on('error', (err: any) => {
      console.log(err); 
    });
  }

  isAuthenticated(): boolean {
    if (!this.heldToken) {
      return false;
    }

    if (this.heldToken.expiresAt < new Date()) {
      return false;
    }

    return true;
  }

  getUser(): ICurrentUser | undefined {
    return this.currentUser;
  }

  getAccessToken(): string | undefined {
    if (this.heldToken) {
      return this.heldToken.token;
    }

    return undefined;
  }

  async logout() {
    await this.oktaAuth.signOut();
    localStorage.clear();
    this.oktaAuth.tokenManager.clear();  
    localStorage.removeItem('userEmail');
    this.oktaAuth.clearStorage();
    this.oktaAuth.closeSession();
    this.loggedOut.emit();
  
  }

}

interface HeldToken {
  token: string;
  expiresAt: Date;
}

export interface ICurrentUser {
  Groups: string[];
  aud: string;
  auth_time: number;
  cid: string;
  email: string;
  exp: number;
  firstName: string;
  iat: number;
  iss: string;
  jti: string;
  lastName: string;
  scp: string[];
  sub: string;
  uid: string;
  ver: number;
}
